// extracted by mini-css-extract-plugin
export default {"swanCtaMain":"HOC_swanCtaMain__RU8vj","swanCtaMain__logo":"HOC_swanCtaMain__logo__Ls99Z"};